module.exports = __webpack_public_path__ + "img/album10_08.ce75f42a.jpg";